import { FormEvent, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import InputText from "../components/Input/InputText";
import ErrorText from "../components/Typography/ErrorText";
import LandingIntro from "../features/user/components/LandingIntro";
import { useAuth } from "../hooks/useAuth";
import { execQuery, mutations } from "../graphql";
import { Hub } from "@aws-amplify/core";

function Register() {
  const Auth = useAuth();
  const navigate = useNavigate();
  const INITIAL_REGISTER_OBJ = {
    username: "",
    password: "",
    email: "",
  };

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [registerObj, setRegisterObj] = useState(INITIAL_REGISTER_OBJ);

  useEffect(() => {
    return Hub.listen("auth", ({ payload: { event, data } }) => {
      switch (event) {
        case "autoSignIn":
          return execQuery(mutations.createUser, {
            username: registerObj.username,
            email: registerObj.email,
          }).then(() => navigate("/"));
        case "autoSignIn_failure":
          console.log("autoSignIn_failure", data);
          setErrorMessage(data.message);
          break;
      }
    });
  }, [registerObj.username, registerObj.email, navigate]);

  const submitForm = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErrorMessage("");

    if (registerObj.username.trim() === "")
      return setErrorMessage("Username is required! (use any value)");
    if (registerObj.password.trim() === "")
      return setErrorMessage("Password is required! (use any value)");
    else {
      setLoading(true);
      // Call API to check user credentials and save token in localstorage
      return Auth.signUp({
        username: registerObj.username,
        password: registerObj.password,
        email: registerObj.email,
      })
        .catch((err) => {
          setErrorMessage(err.message);
        })
        .finally(() => setLoading(false));
    }
  };

  const updateFormValue = ({
    name,
    value,
  }: {
    name: string;
    value: string;
  }) => {
    setErrorMessage("");
    setRegisterObj({ ...registerObj, [name]: value });
  };

  return (
    <div className="flex min-h-screen items-center bg-base-200">
      <div className="card mx-auto w-full max-w-5xl  shadow-xl">
        <div className="grid  grid-cols-1 rounded-xl  bg-base-100 md:grid-cols-2">
          <div className="">
            <LandingIntro />
          </div>
          <div className="px-10 py-24">
            <h2 className="mb-2 text-center text-2xl font-semibold">
              Register
            </h2>
            <form onSubmit={submitForm}>
              <div className="mb-4">
                <InputText
                  type="text"
                  defaultValue={registerObj.username}
                  name="username"
                  containerStyle="mt-4"
                  labelTitle="Username"
                  autoComplete="username"
                  updateFormValue={updateFormValue}
                />

                <InputText
                  defaultValue={registerObj.email}
                  name="email"
                  type="email"
                  containerStyle="mt-4"
                  labelTitle="Email"
                  updateFormValue={updateFormValue}
                  autoComplete="email"
                />

                <InputText
                  defaultValue={registerObj.password}
                  type="password"
                  name="password"
                  containerStyle="mt-4"
                  labelTitle="Password"
                  autoComplete="new-password"
                  updateFormValue={updateFormValue}
                />
              </div>

              <ErrorText styleClass="mt-8">{errorMessage}</ErrorText>
              <button
                type="submit"
                className={
                  "btn btn-primary mt-2 w-full" + (loading ? " loading" : "")
                }
              >
                Register
              </button>

              <div className="mt-4 text-center">
                Already have an account?{" "}
                <Link to="/login">
                  <span className="  inline-block  transition duration-200 hover:cursor-pointer hover:text-primary hover:underline">
                    Login
                  </span>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
